module.exports = __webpack_public_path__ + "img/db_logo.3f3f7e52.svg";